<div class="shorts-slider-item admin-playlist-card-container1"
  [ngClass]="{'shorts-slider-item-selector': !slidItemClass}" (click)="playlistClick(shorts)" style="width:200px;">
  <div class="shorts-slider-img" [attr.shorts-slug]="shorts.slug" lazy-load-images (click)="playlistClick(shorts);">
    <img [attr.alt]="shorts.title" style="width:200px;height:300px;cursor:pointer;" [src]="shorts.thumbnail_image"
      onError="this.src='https://dyo1wwfvu9av7.cloudfront.net/jkp/common/default-poster.png'">

    <!--span *ngIf="type === 'favorite'" class="shorts-like-box" (click)="favourite(shorts, $event)"><i
        [ngClass]="'liked'"></i></span>
    <div *ngIf="shorts?.video_duration" class="duration">{{shorts?.video_duration}}</div-->
    <span class="premium-tag pts" *ngIf="shorts?.is_premium === 1"> 
      P
    </span>
  </div>
  <div class="shorts-slider-item2">
    <div class="slider-content">
      <h3 class="category-text" (click)="playlistClick(shorts);">
        {{shorts?.title}}
      </h3>
    </div>
  </div>
</div>
<!--span class="shorts-premium-tag" *ngIf="shorts?.is_premium === 1"> {{ 'VIDEO_CARD.PREMIUM' | translate }}</span-->